export const pluginFlags = Object.freeze({
  contact: __PLUGIN_CONTACT__,
  mailinglist: __PLUGIN_MAILING_LIST__,
});
